import React from "react";
import { Modal } from "antd";
import moment from "moment";
import { Localize } from "components/service";


const StaffManualCheckoutModal = ({ target, event, pending, onConfirm, onCancel }) => {
    const worker = target?.attendanceRow?.worker;
    const workerName = `${ worker?.name || "" } ${ worker?.surname || "" }`.trim();
    const checkInAt = target?.session?.check_in_at;
    const checkInDate = checkInAt ? moment(checkInAt, [ moment.ISO_8601, "YYYY-MM-DD HH:mm:ss" ], true) : null;
    const checkIn = checkInDate?.isValid() ? checkInDate.format("DD.MM.YYYY, HH:mm:ss") : "—";

    return (
        <Modal
            className="modal-standard staff-manual-checkout-modal"
            centered
            visible={ Boolean(target) }
            title={ <Localize>STAFF_MANAGEMENT.ManualCheckout_ConfirmTitle</Localize> }
            okText={ <Localize>STAFF_MANAGEMENT.Action_ManualCheckout</Localize> }
            cancelText={ <Localize>GLOBAL.Button_Text_Cancel</Localize> }
            confirmLoading={ pending }
            okButtonProps={ { disabled: Boolean(pending) } }
            cancelButtonProps={ { disabled: Boolean(pending) } }
            closable={ !pending }
            keyboard={ !pending }
            maskClosable={ !pending }
            destroyOnClose={ true }
            onOk={ () => {
                if (target && !pending)
                {
                    onConfirm();
                }
            } }
            onCancel={ () => {
                if (!pending)
                {
                    onCancel();
                }
            } }>
            { target &&
                <Localize
                    worker={ workerName || "—" }
                    event={ event?.title || "—" }
                    checkIn={ checkIn }>
                    STAFF_MANAGEMENT.ManualCheckout_ConfirmText
                </Localize>
            }
        </Modal>
    );
};

export default StaffManualCheckoutModal;
